import {
  Award,
  DollarSign,
  Gamepad2,
  Heart,
  Leaf,
  Server,
  Shield,
  Target,
  Users,
  Zap,
} from "lucide-react";
import React from "react";
import "./about.css";

interface Partner {
  name: string;
  logo: string;
  description: string;
}

interface TeamMember {
  name: string;
  role: string;
  description: string;
  avatar: string;
}

interface Objective {
  icon: React.ElementType;
  title: string;
  description: string;
  emoji: string;
}

const About: React.FC = () => {
  const partners: Partner[] = [
    {
      name: "Pinous-Heberg",
      logo: "/logo_pinou.png",
      description: "",
    },
    {
      name: "LWS",
      logo: "/lws.png",
      description: "",
    },
    {
      name: "crapt-pay",
      logo: "/neo.png",
      description: "développeur de plugins/mods minecraft sur messure",
    },
    {
      name: "light-city-rp",
      logo: "/neo.png",
      description: "Serveur NovaLife Roleplay",
    },
    {
      name: "mcminelab",
      logo: "/neo.png",
      description: "développeur de plugins/mods minecraft sur messure",
    },
    {
      name: "Akaria RP",
      logo: "/neo.png",
      description: "Serveur NovaLife Roleplay",
    },
    {
      name: "Lakeside RP",
      logo: "/neo.png",
      description: "Serveur NovaLife Roleplay",
    },
    {
      name: "Shourhost.py",
      logo: "/neo.png",
      description: "developer de bot discord",
    },
  ];

  const objectives: Objective[] = [
    {
      icon: Leaf,
      title: "Transition écologique",
      description: "Accompagner les joueurs vers la transition écologique",
      emoji: "🌱",
    },
    {
      icon: DollarSign,
      title: "Prix bas",
      description: "Proposer les meilleures offres à bas prix",
      emoji: "💰",
    },
    {
      icon: Shield,
      title: "Performance & sécurité",
      description:
        "Garantir une performance constante et une sécurité optimale",
      emoji: "🛡️",
    },
    {
      icon: Gamepad2,
      title: "Support de Jeux",
      description: "Supporter 50+ jeux supplémentaires d'ici 2027",
      emoji: "🎮",
    },
    {
      icon: Users,
      title: "Expérience Utilisateur",
      description:
        "Améliorer continuellement l'expérience utilisateur et la satisfaction client en intégrant les retours et en innovant nos interfaces",
      emoji: "🦸",
    },
    {
      icon: Server,
      title: "Data center",
      description: "Construire notre premier Data Center",
      emoji: "🏢",
    },
  ];

  const teamMembers: TeamMember[] = [
    {
      name: "Luca HALLET",
      role: "Président & PDG",
      description:
        "Passionné de gaming et d'infrastructure, Luca a créé l'entreprise avec la vision de démocratiser l'hébergement gaming.",
      avatar: "LH",
    },
    {
      name: "Lunary",
      role: "Technicien",
      description: "Technicien spécialisé dans le gaming.",
      avatar: "L",
    },
    {
      name: "Romain CARRECAR",
      role: "Technicien",
      description: "Spécialiste dans les serveur Novalife : amboise.",
      avatar: "RC",
    },
    {
      name: "A RECRUTER",
      role: "N/A",
      description: "",
      avatar: "N/A",
    },
  ];

  const timelineEvents = [
    {
      year: "2025",
      title: "Les débuts",
      description:
        "Achat de mon premier serveur dédié pour héberger des serveurs de jeux.",
    },
    {
      year: "2025",
      title: "Expansion",
      description:
        "Publication du site web et lancement officiel des services d'hébergement gaming. Acquisition des premiers clients et développement de l'infrastructure.",
    },
    {
      year: "2025",
      title: "Croissance",
      description: "Heberge les plus gros serveurs NovaLife de France.",
    },
    {
      year: "2025",
      title: "Innovation",
      description:
        "Nous dasboard pour les clients, et nouveau site pour achat des offres.",
    },
    {
      year: "2025",
      title: "Confiance et stabilité",
      description:
        "Notre site internet est désormais pleinement opérationnel, et nous accompagnons plus de 20 clients actifs dans leurs projets grâce à un service fiable et personnalisé.",
    },
  ];

  return (
    <div className="about-container">
      {/* Background Effects */}
      <div className="background-overlay"></div>
      <div className="background-orb orb-1"></div>
      <div className="background-orb orb-2"></div>
      <div className="floating-particles"></div>

      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="company-icon animate-bounce-slow">🏰</div>
          <h1 className="hero-title animate-fade-in-up">À PROPOS DE NOUS</h1>
          <p
            className="hero-subtitle animate-fade-in-up"
            style={{ animationDelay: "0.2s" }}
          >
            Découvrez l'histoire de notre entreprise, nos valeurs, nos objectifs
            et l'équipe passionnée qui travaille chaque jour pour vous offrir le
            meilleur hébergement gaming.
          </p>
        </div>
      </div>

      {/* Comment tout a commencé */}
      <section
        className="about-section animate-fade-in-up"
        style={{ animationDelay: "0.4s" }}
      >
        <div className="section-header">
          <h2 className="section-title">Comment tout a commencé</h2>
          <p className="section-subtitle">
            L'histoire de notre passion pour le gaming et l'hébergement
          </p>
        </div>

        <div className="story-content">
          <p
            style={{
              fontSize: "1.2rem",
              lineHeight: "1.8",
              color: "var(--text-gray)",
              marginBottom: "2rem",
              textAlign: "center",
            }}
          >
            Tout a commencé en 2025. Un jeune étudiant en informatique,
            passionné par les nouvelles technologies, décide de se lancer dans
            un projet ambitieux : créer son propre hébergeur. Son objectif est
            clair apprendre, expérimenter, progresser dans le domaine de
            l’informatique tout en proposant une alternative fiable et
            accessible aux personne recherchant un hébergeur. Face à une
            industrie saturée d’acteurs aux promesses douteuses, avec des prix
            élevés pour des performances souvent décevantes, il veut faire la
            différence. Il s’engage à offrir le meilleur rapport qualité/prix du
            marché, en proposant l’un des hébergements les moins chers de France
            sans sacrifier la performance. Plus qu’un simple projet personnel,
            c’est une réponse à un besoin réel : celui d’un hébergeur honnête,
            performant, et accessible à tous.
          </p>

          <div className="story-timeline-vertical">
            <div className="timeline-line"></div>
            {timelineEvents.map((event, index) => (
              <div key={event.year} className="timeline-event">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">{event.year}</div>
                  <h3 className="timeline-title">{event.title}</h3>
                  <p className="timeline-description">{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Objectifs à long terme */}
      <section
        className="about-section animate-fade-in-up"
        style={{ animationDelay: "0.8s" }}
      >
        <div className="section-header">
          <h2 className="section-title">Nos objectifs à long terme</h2>
          <p className="section-subtitle">
            Les défis que nous nous fixons pour l'avenir
          </p>
        </div>

        <div className="objectives-grid">
          {objectives.map((objective, index) => (
            <div
              key={objective.title}
              className="objective-card animate-fade-in-up"
              style={{ animationDelay: `${1.0 + index * 0.1}s` }}
            >
              <span className="objective-icon">{objective.emoji}</span>
              <h3 className="objective-title">{objective.title}</h3>
              <p className="objective-description">{objective.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Partenaires & Prestataires */}
      <section
        className="about-section animate-fade-in-up"
        style={{ animationDelay: "1.2s" }}
      >
        <div className="section-header">
          <h2 className="section-title">Nos partenaires & prestataires</h2>
          <p className="section-subtitle">
            Les entreprises de confiance qui nous accompagnent
          </p>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div
              key={partner.name}
              className="partner-card animate-fade-in-up"
              style={{ animationDelay: `${1.4 + index * 0.1}s` }}
            >
              <div
                className="partner-fallback"
                style={{
                  width: "110px",
                  height: "110px",
                  borderRadius: "16px",
                  background:
                    "linear-gradient(135deg, var(--primary-blue), var(--primary-purple))",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.1rem",
                  fontWeight: "800",
                  color: "var(--text-white)",
                  marginBottom: "1rem",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={partner.logo}
                  alt={`Logo ${partner.name}`}
                  style={{
                    width: "80%",
                    height: "80%",
                    objectFit: "contain",
                    display: "block",
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = "none";
                    const fallback =
                      target.nextElementSibling as HTMLSpanElement;
                    if (fallback) {
                      fallback.style.display = "block";
                    }
                  }}
                />
                <span
                  style={{
                    display: "none",
                    width: "100%",
                    textAlign: "center",
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    padding: "0 8px",
                    wordBreak: "break-word",
                  }}
                >
                  {partner.name}
                </span>
              </div>
              <h3 className="partner-name">{partner.name}</h3>
              <p className="partner-description">{partner.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Notre équipe */}
      <section
        className="about-section animate-fade-in-up"
        style={{ animationDelay: "1.6s" }}
      >
        <div className="section-header">
          <h2 className="section-title">Notre équipe</h2>
          <p className="section-subtitle">
            Les personnes passionnées derrière nos services
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div
              key={member.name}
              className="team-member animate-fade-in-up"
              style={{ animationDelay: `${1.8 + index * 0.1}s` }}
            >
              <div className="member-avatar">{member.avatar}</div>
              <h3 className="member-name">{member.name}</h3>
              <p className="member-role">{member.role}</p>
              <p className="member-description">{member.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Nos valeurs */}
      <section
        className="about-section animate-fade-in-up"
        style={{ animationDelay: "2.0s" }}
      >
        <div className="section-header">
          <h2 className="section-title">Nos valeurs</h2>
          <p className="section-subtitle">
            Les principes qui guident nos actions au quotidien
          </p>
        </div>

        <div className="objectives-grid">
          <div className="objective-card">
            <Target
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-blue)" }}
            />
            <h3 className="objective-title">Excellence</h3>
            <p className="objective-description">
              Nous visons l'excellence dans tout ce que nous faisons, de la
              qualité de nos serveurs à notre support client.
            </p>
          </div>

          <div className="objective-card">
            <Heart
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-red)" }}
            />
            <h3 className="objective-title">Passion</h3>
            <p className="objective-description">
              Notre passion pour le gaming nous pousse à créer des solutions
              toujours plus innovantes et performantes.
            </p>
          </div>

          <div className="objective-card">
            <Award
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-yellow)" }}
            />
            <h3 className="objective-title">Intégrité</h3>
            <p className="objective-description">
              Transparence, honnêteté et respect sont au cœur de nos relations
              avec nos clients et partenaires.
            </p>
          </div>

          <div className="objective-card">
            <Zap
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-purple)" }}
            />
            <h3 className="objective-title">Innovation</h3>
            <p className="objective-description">
              Nous innovons constamment pour anticiper les besoins de la
              communauté gaming et proposer des solutions modernes.
            </p>
          </div>

          <div className="objective-card">
            <Shield
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-green)" }}
            />
            <h3 className="objective-title">Sécurité</h3>
            <p className="objective-description">
              La sécurité de vos données et de vos serveurs est notre priorité
              absolue.
            </p>
          </div>

          <div className="objective-card">
            <Users
              className="objective-icon"
              size={64}
              style={{ color: "var(--primary-blue)" }}
            />
            <h3 className="objective-title">Esprit d'équipe</h3>
            <p className="objective-description">
              Nous avançons ensemble, en équipe, pour offrir le meilleur à notre
              communauté.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
